export const getCloudinaryImage = (src, w, h) => {
  return `https://res.cloudinary.com/crop/image/fetch/f_auto,q_80,c_scale,h_${h},w_${w}/${src}`;
};
